import { useEffect, useMemo, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/trainerCaroussel.modules.css";

const SLIDE_DURATION = 4000;

/**
 * Karuzela trenerek dla podstrony lokalizacji.
 *
 * instructors — gotowa tablica z public_site/schedule, przefiltrowana
 *   w location.jsx przez instructorsForPage(). Komponent nic nie pobiera.
 */
export default function TrainerCarousel({ color = "#C2001C", instructors = [] }) {
  const [index, setIndex] = useState(0);

  const visible = useMemo(
    () =>
      (Array.isArray(instructors) ? instructors : [])
        .filter((t) => t && t.name)
        .map((t, i) => ({
          key: t.name || `trainer-${i}`,
          name: t.name || "",
          role: t.profession || "",
          bio: t.description || "",
          photo: t.photoUrl || null,
        })),
    [instructors]
  );

  const slideCount = visible.length;

  useEffect(() => {
    if (index >= slideCount) setIndex(0);
  }, [slideCount, index]);

  useEffect(() => {
    if (slideCount <= 1) return;
    const t = setInterval(() => setIndex((prev) => (prev + 1) % slideCount), SLIDE_DURATION);
    return () => clearInterval(t);
  }, [slideCount]);

  if (slideCount === 0) {
    return (
      <div
        style={{
          width: "92%",
          maxWidth: "700px",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: 600,
          color: "rgba(0,0,0,0.55)",
          padding: "18px",
        }}
      >
        Kadrę dla tej placówki podamy wkrótce.
      </div>
    );
  }

  return (
    <div
      className="trc_wrap"
      style={{
        backgroundColor: color,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "30px",
        overflow: "hidden",
      }}
    >
      <Carousel
        activeIndex={index}
        onSelect={(i) => setIndex(i)}
        indicators={false}
        controls={false}
        touch
        fade
        style={{ width: "100%" }}
      >
        {visible.map((t) => (
          <Carousel.Item key={t.key} style={{ width: "100%" }}>
            <TrainerSlide trainer={t} color={color} />
          </Carousel.Item>
        ))}
      </Carousel>

      {slideCount > 1 ? (
        <div className="bars-container" role="tablist" aria-label="Nawigacja slajdów">
          {visible.map((t, i) => {
            const isActive = i === index;
            const isCompleted = index > i;

            return (
              <button
                key={t.key}
                type="button"
                className="bar-btn"
                onClick={() => setIndex(i)}
                role="tab"
                aria-selected={isActive}
                aria-label={`Slajd ${i + 1}: ${t.name}`}
              >
                <span className={`bar ${isCompleted ? "bar-completed" : ""}`}>
                  {isActive && (
                    <span
                      key={`fill-${i}-${index}`}
                      className="bar-fill"
                      style={{ animationDuration: `${SLIDE_DURATION}ms` }}
                    />
                  )}
                </span>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

function TrainerSlide({ trainer, color }) {
  const { name, role, bio, photo } = trainer;

  return (
    <section
      className="trc_slide"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        background: color,
      }}
    >
      {photo ? (
        <img
          className="trc_img"
          src={photo}
          alt={role ? `${name} - ${role}` : name}
          loading="lazy"
          style={{ width: "auto" }}
        />
      ) : null}

      <div className="trc_box" style={{ display: "flex", flexDirection: "column" }}>
        <h3 className="trc_h1" style={{ color: "rgb(250,250,250)", fontWeight: "bold" }}>
          {name}
        </h3>
        <h4 className="trc_h3" style={{ color: "rgb(250,250,250)" }}>
          {role}
        </h4>
        <p
          className="trc_h2"
          style={{ color: "rgb(250,250,250)", fontWeight: "normal", whiteSpace: "pre-line" }}
        >
          {bio}
        </p>
      </div>
    </section>
  );
}